import{useFormContext as e}from"./useFormContext.js";const s=(s,t)=>{const{actions:{setValue:l,focus:u,blur:o},state:{fields:a,values:r}}=e();return{setFieldValue:e=>l(s,e,t),focusField:()=>u(s),blurField:()=>o(s),meta:a[s],value:r[s],values:r}};export{s as useFieldContext};
//# sourceMappingURL=useFieldContext.js.map
